import React from 'react';
import moment from 'moment';
import CurrencyFormat from 'react-currency-format';
import { CARD_TYPES, DATE_FORMAT, HOUR_MINS, PAYMENT_METHODS, REGEX } from './constant';
// import { env } from './dev';
import { NGS_SINGPASS_ENV } from './constant';
import CryptoJS from 'crypto-js';
import AWS from 'aws-sdk';
import { AWS_SECRET_KEY_ID, AWS_SECRET_ACCESS_KEY, CRYPTO_ACCESS_KEY } from './constant';
import { CREDIT_CARD, PAYMENT_OPTIONS } from '.';

const env = NGS_SINGPASS_ENV?.toLowerCase();

export const SSMKeys = {
    stripePk: `/${env}/enc/common/STRIPE_PK`,
    worldPayCSE: `/${env}/enc/common/wp/WPCSE`,
    authPoolId: `/${env}/enc/common/AWS_USER_POOL_ID`,
    authClientId: `/${env}/enc/common/AWS_CLIENT_ID`,
    gpay3DSGD: `/${env}/enc/common/wp/GPKEY`,
    gpayNO3DSGD: `/${env}/enc/common/wp/GP_NO3D_KEY`,
}

AWS.config.update({
    region: 'ap-southeast-1',
    accessKeyId: decryptData(AWS_SECRET_KEY_ID),
    secretAccessKey: decryptData(AWS_SECRET_ACCESS_KEY),
});

const ssm = new AWS.SSM()

export const getSecret = async (name) => {
    const res = await ssm
        .getParameter({
            Name: name,
            WithDecryption: true
        })
        .promise();
    return res.Parameter.Value;
}

export function encryptData(data) {
    const encryptedData = CryptoJS.AES.encrypt(data, CRYPTO_ACCESS_KEY).toString();
    return encryptedData;
}

export function decryptData(data) {
    const decryptedData = CryptoJS.AES.decrypt(data, CRYPTO_ACCESS_KEY).toString(CryptoJS.enc.Utf8);
    return decryptedData;
}

const TERMS_N_CONDITION_Link = 'https://cpas.org.sg/about-cpas/data-protection-policy/';
export const Common = {
    getReadableDateFormat,
    navigateToLink,
    standardDateFormat,
    disableFutureDt,
    copyURL,
    isValidField,
    mobileFormatter,
    formatNumber,
    dateFormatterLeftBlock,
    stringTitleCase,
    convertToLowerCase,
    TERMS_N_CONDITION_Link,
    nricFormatter,
    patronDateFormatterLeftBlock,
    resetNavigation,
    getImgCreditCard,
    isMobile,
};

function nricFormatter(value) {
    if (Common.isValidField(value)) {
        let valLength = value.length;
        var last4 = value.substr(valLength - 4);
        var bull = '';
        var newVal;
        for (let i = 1; i <= valLength - 4; i++) {
            bull = bull.concat('<span class="dot-formatted"> </span>');
        }
        newVal = bull.concat(last4);
    } else {
        newVal = '-';
    }
    return newVal
}

function stringTitleCase(value) {
    return value.toLowerCase().replace(REGEX.TITLECASE, s => s.toUpperCase())
}

function isValidField(value) {
    if (value === "" || value === null || value === 'null' || value === 'NA' || value === " " || value === undefined || value === "NULL" || value === [] || value === 0 || value === '0'
    ) {
        return false
    } else {
        return true
    }
}
function convertToLowerCase(value) {
    if (value === "" || value === null || value === 'NA' || value === " " || value === undefined
    ) {
        return value
    } else {
        return value.toLowerCase()
    }
}
function getReadableDateFormat(value) {
    var given = moment("2021-06-28 17:00:00", "YYYY-MM-DD hh:mm:ss");
    var current = moment();
    var diff = moment.duration(given.diff(current));
}

function formatNumber(e) {
    if (!/[0-9]/.test(e.clipboardData.getData('text/plain'))) {
        e.preventDefault();
    }
    else {
        var val = e.clipboardData.getData('text/plain').replace(/[^\d]/g, '').replace(/(.{4})/g, '$1 ').trim();
        setTimeout(() => {
            e.target.value = '';
            e.target.value = val;
            e.preventDefault();
        }, 4);
        // 2223003122003222
    }
}

function navigateToLink(navlink) {
    window.open(navlink, '_blank');
}

function standardDateFormat(cell) {
    if (!cell) { return ""; }
    if (typeof cell === 'string') {
        return `${moment(cell).format('D MMM YYYY')}`;
    }
}

function disableFutureDt(current) {
    const today = moment();
    return current.isBefore(today)
}

function copyURL() {
    const elem = document.createElement('input');
    elem.value = document.URL;
    // elem.hidden = true;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand('copy');
    document.body.removeChild(elem);
}

function mobileFormatter(cell, row) {
    if (Common.isValidField(cell)) {
        return <CurrencyFormat displayType={'text'} format="+## #### ######" mask="" value={cell} />
    } else {
        return '-'; //<span className="d-block text-center no-value">-</span>
    }
}

function dateFormatterLeftBlock(cell) {
    if (!cell) { return ""; }

    let dateTime;
    if (typeof cell === 'string') {
        dateTime = cell.trim().split(' ');
    }

    if (typeof cell === 'string' && dateTime.length > 1) {
        return `${moment(new Date(dateTime[0].replace(/-/g, "/"))).format(DATE_FORMAT)} | ${moment((dateTime[1] + ' ' + dateTime[2]), [HOUR_MINS]).format(HOUR_MINS)}`;
    } else {
        return `${moment(cell).format(DATE_FORMAT)} | ${moment(cell).format(HOUR_MINS)}`;
    }

}

function patronDateFormatterLeftBlock(cell) {
    if (!cell) { return ""; }

    let dateTime;
    if (typeof cell === 'string') {
        dateTime = cell.trim().split(' ');
    }

    if (typeof cell === 'string' && dateTime.length > 1) {
        return `${moment(new Date(dateTime[0].replace(/-/g, "/"))).format('ddd DD MMM YYYY')} | ${moment((dateTime[1] + ' ' + dateTime[2]), [HOUR_MINS]).format(HOUR_MINS)}`;
    } else {
        return `${moment(cell).format(DATE_FORMAT)} | ${moment(cell).format(HOUR_MINS)}`;
    }

}

export const calculateDayLeft=(value) =>{
    let startDate = new Date(moment().format("MM/DD/YYYY"));
    let endDate = new Date(moment(value).format("MM/DD/YYYY"));

    var Difference_In_Time = endDate.getTime() - startDate.getTime();
    var dayDiff = Math.round(Difference_In_Time / (1000 * 3600 * 24));
    if (dayDiff > 1)
        return (dayDiff + 1) + ' Days left'
    else
        return (dayDiff + 1) + ' Day left'
}

function resetNavigation(props) {
    props.resetAllSettings();
    let data = null;
    data = localStorage.getItem('CurrPage')
    data = Common.isValidField(data) ? data : null
    let donationMethod = data ? data : props.donationMethod
    if (donationMethod === 'campaign') {
        props.history.push('/campaign/payment')
    } else if (donationMethod === 'cause') {
        props.history.push('/payments')
    } 
    // else if (donationMethod === 'patron') {
    //     props.history.push('/patrons/payment')
    // } else if (donationMethod === 'adoptartwork') {
    //     props.history.push('/adoptnow/payment')
    // } 
    else {
        props.history.push('/payments')
    }
}

function getImgCreditCard(paymentType, paymentMethod) {
    let type = paymentType ?? false;
    let method = paymentMethod ? paymentMethod.toLowerCase().replace(/\s+/g, '') : false;
    let imagePath = null;

    if (method && parseInt(method).toString() === 'NaN') {
        if (method === PAYMENT_METHODS.GOOGLE_PAY) {
            imagePath = { path: PAYMENT_OPTIONS.cardImages.googlepayPNG, name: '' };
        } else if (method === PAYMENT_METHODS.APPLE_PAY) {
            imagePath = { path: PAYMENT_OPTIONS.cardImages.applepayPNG, name: '' };
        } else if (method === PAYMENT_METHODS.ALI_PAY) {
            imagePath = { path: PAYMENT_OPTIONS.cardImages.alipayPNG, name: '' };
        } else if (method === PAYMENT_METHODS.GRAB_PAY) {
            imagePath = { path: PAYMENT_OPTIONS.cardImages.grabpayPNG, name: 'GrabPay' };
        } else if (method === PAYMENT_METHODS.NETS) {
            imagePath = { path: '', name: 'NETS' };
        } else if (method === PAYMENT_METHODS.STATIC_PAYNOW_QR_CODE || method === PAYMENT_METHODS.PAY_NOW) {
            imagePath = { path: PAYMENT_OPTIONS.cardImages.paynowPNG, name: '' };
        } else if (method === PAYMENT_METHODS.STATIC_PAYNOW) {
            imagePath = { path: '', name: 'Static PayNow' };
        } else if (method === PAYMENT_METHODS.BANK_TRANSFER) {
            imagePath = { path: '', name: 'Bank Transfer' };
        } else if (method === PAYMENT_METHODS.CASH) {
            imagePath = { path: '', name: 'Cash' };
        } else if (method === PAYMENT_METHODS.CHEQUE) {
            imagePath = { path: '', name: 'Cheque' };
        }
    } else {
        let cardNumber = method ? String(method) : '';
        if (type === CARD_TYPES.VISA.toLowerCase()) {
            imagePath = { path: CREDIT_CARD.cardImages.Visa, name: cardNumber };
        } else if (type === CARD_TYPES.MASTERCARD.toLowerCase()) {
            imagePath = { path: CREDIT_CARD.cardImages.Mastercard, name: cardNumber };
        } else if (type === CARD_TYPES.AMEX.toLowerCase()) {
            imagePath = { path: CREDIT_CARD.cardImages.AmericanExpress, name: cardNumber };
        } else if (type === CARD_TYPES.JCB.toLowerCase()) {
            imagePath = { path: CREDIT_CARD.cardImages.JCB, name: cardNumber };
        } else if (type === CARD_TYPES.UNIONPAY.toLowerCase()) {
            imagePath = { path: CREDIT_CARD.cardImages.UnionPay, name: cardNumber };
        } else if (type === CARD_TYPES.DINNERSCLUB.toLowerCase()) { // untested due to stripe issue
            imagePath = { path: CREDIT_CARD.cardImages.DinersClub, name: cardNumber };
        } else {
            imagePath = { path: CREDIT_CARD.cardImages.DefaultCard, name: cardNumber };
        }
    }
    return imagePath;
}

function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}